export default __webpack_public_path__ + "static/zhi-1-fe20e41076d886c68261758e8f508f9c.jpg";